import { patch } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string;
  ventCapId: number;
  updates: {
    planCoordinateX?: number | null;
    planCoordinateY?: number | null;
    label?: string | null;
    comment?: string | null;
    sizeMm?: number;
    type?: 'PASSIVE' | 'ACTIVE';
    installedAt?: string;
  };
}

export function useUpdateVentCap() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, ventCapId, updates }: Params) =>
      patch({
        url: `/api/projects/${projectId}/ventcaps/${ventCapId}`,
        body: updates,
      }),
    onSuccess: (_, { projectId, installationId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getVentCaps(projectId, installationId),
      });
    },
  });

  const updateVentCap = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    updateVentCap,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
